import { useBuildingById } from '@/entities/Building'
import { Residential } from '@/shared/api/topli/TopliApi'
import { useEffect, useState, useRef } from 'react'

export const useResidentialBuildings = (residential: Residential) => {
  const [activeTab, setActiveTab] = useState<string | null>(null)
  const buildingIdsRef = useRef<string>('')

  useEffect(() => {
    const ids = residential.buildings
      .map(b => String(b.id))
      .sort()
      .join(',')
    if (buildingIdsRef.current === ids) return
    buildingIdsRef.current = ids

    setActiveTab(prev => {
      const list = residential.buildings.map(b => String(b.id))
      if (prev == null) return list[0] ?? null
      if (list.includes(prev)) return prev
      return list[0] ?? null
    })
  }, [residential])

  const { data: currentBuilding, isLoading } = useBuildingById(
    activeTab ? Number(activeTab) : undefined,
  )

  return {
    activeTab,
    currentBuilding,
    isLoading,
    setActiveTab,
  }
}
